import * as React from "react";
import { Button, StyleProp, StyleSheet, ViewStyle } from "react-native";

import { View } from "../../components/Themed";
import useCreateVideo from "../../hooks/videos/useCreateVideo";
import {Video} from "../../types";

export interface VideoListItemProps {
  style?: StyleProp<ViewStyle>;
  video?: Video;
}

function VideoListItem({ style }: VideoListItemProps) {
  const { mutateAsync: createVideo } = useCreateVideo();

  return (
    <View style={[styles.container, style]}>
      <Button
        title="Add Video"
        onPress={async () => {
          try {
            await createVideo({ url: "https://vimeo.com/656099733" });
          } catch (err) {
            // TODO
          }
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default VideoListItem;
